import z from 'zod';

export const validationSchema = z
  .object({
    paymentMethodId: z.string().min(1, 'Please select a payment method'),
    stripePaymentMethodId: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.paymentMethodId === 'add-new-card' &&
      !data.stripePaymentMethodId
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please complete your card details',
        path: ['stripePaymentMethodId'],
      });
    }
  });
